<template>
    <BasePanel v-if="showDoorsaleInformation">
        <template #title>Haal een ticket aan de deur</template>

        <template #default>
            <!-- eslint-disable -->
            <p v-html="event.doorsaleInformation" />
            <!-- eslint-enable -->

            <br>

            <BaseButton
                class="button button--secondary button--stretch"
                @click="showDoorsaleInformation = false"
            >
                Begrepen
            </BaseButton>
        </template>
    </BasePanel>

    <BasePanel v-else-if="can('make-reservations')">
        <template #title>Reserveer je ticket in een paar stappen:</template>

        <template #default>
            <!-- eslint-disable vue/no-v-html -->
            <p
                v-if="event.reservationInformation"
                v-html="event.reservationInformation"
            />

            <p
                v-if="event.ticketPickUpInformation"
                v-html="event.ticketPickUpInformation"
            />
            <!-- eslint-enable vue/no-v-html -->

            <p
                v-if="
                    ticketPricing.needsPayment
                        && ticketPricing.parsedMoneySaved"
            >
                Je bespaart €{{ ticketPricing.parsedMoneySaved }} met je We Are Public-pas
            </p>

            <BaseButton
                v-if="event.ticketPartnerUrl"
                :href="event.ticketPartnerUrl"
                target="_blank"
                rel="noreferrer noopener"
                element="a"
                style="margin-top: var(--spacing-lg, 1.5rem);"
                class="button--secondary"
            >
                {{ buttonText }}
            </BaseButton>

            <div />

            <BaseButton
                v-if="event.doorsaleEnabled"
                type="button"
                class="button button--stretch"
                style="text-decoration: underline; margin-top: var(--spacing-2xs, .25rem);"
                @click="showDoorsaleInformation = true"
            >
                Of haal een ticket aan de deur
            </BaseButton>
        </template>
    </BasePanel>

    <EventReservationPanelBecomeMember
        v-else
        :event
    />
</template>

<script setup lang="ts">
const props = defineProps<{
    event: EventDate
}>();

const showDoorsaleInformation = ref(false);

const eventsStore = useEventsStore();

const ticketPricing = computed(() => eventsStore.ticketPricing);

const userStore = useUserStore();
const { can } = userStore;

const buttonText = computed(() => {
    if (
        !props.event?.partnerCollectsAdditionalFee
        && ticketPricing.value.needsPayment
        && ticketPricing.value.parsedPrice
    ) {
        return `Reserveer. Incasso €${ticketPricing.value.parsedPrice} na bezoek.`;
    }

    return 'Direct reserveren';
});
</script>
